import React from 'react';
import './Hackathons.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Hackathons = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="hackathons">
      <div className="hackathons-content">
        <h2 className="hackathons-heading">{t.hackathonsTitle}</h2>
        
        <div className="hackathons-cards">
          <div className="hackathon-card">
            <h3 className="hackathon-title">{t.hackathonGenaiTitle}</h3>
            <div className="hackathon-image">
              <img 
                src="/images/hackathon-genai-april.jpg" 
                alt="GenAI Hackathon April 2025"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div className="hackathon-content">
              <h4 className="hackathon-subtitle">{t.hackathonGenaiSubtitle}</h4>
              <p className="hackathon-text">
                {t.hackathonGenaiText1}
              </p>
              <p className="hackathon-text">
                {t.hackathonGenaiText2}
              </p>
            </div>
          </div>
          
          <div className="hackathon-card">
            <h3 className="hackathon-title">{t.hackathonAiTitle}</h3>
            <div className="hackathon-image">
              <img 
                src="/images/hackathon-ai-september.jpg" 
                alt="AI-Hackathon September 2025"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div className="hackathon-content">
              <h4 className="hackathon-subtitle">{t.hackathonAiSubtitle}</h4>
              <p className="hackathon-text">
                {t.hackathonAiText1}
              </p>
              <p className="hackathon-text">
                {t.hackathonAiText2}
              </p>
              <p className="hackathon-text">
                {t.hackathonAiText3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hackathons;

